<!-- 2022 美食 -->
<template>
<div class="food">
    <SimpleHead />
    <!-- <TopBanner :banner="banner" /> -->
        <div class="top-baner"><img src="https://media3.imgyb.xyz/media/v1/image/c0f1bf0af428a77086297ecada185f1d.jpeg" alt=""></div>
    <div class="warrp800">
        <div class="good-shop" id="first-floor">
            <div class="cont-row title mrg-btm20">
                <div class="flex-cont"> <a href="https://info.yorkbbs.ca/special/big/c3033af7-90ac-4ee6-b98f-be569aab6968 " target="_blank"> <img src="https://media6.imgyb.xyz/media/v1/image/63bf941bb91490f22df5c61bb4acab0b.png" alt=""></a></div>
                <div class="cont"><a href="https://corp.yorkbbs.ca/ads " class="join-in" target="_blank">我要出现在这里</a></div>
            </div>
            <GoodShop />
        </div>

        <div class="note-content mrg-btm30" id="second-floor">
            <a href="https://forum.yorkbbs.ca/detail/80ad081d-b6ac-46d6-bf1a-d063f8982a57?topic=chat" target="_blank"><img class="pc" src="https://media3.imgyb.xyz/media/v1/image/866bf4083c7d651213716505124df994.png" alt=""></a>
            <a href="https://forum.yorkbbs.ca/detail/80ad081d-b6ac-46d6-bf1a-d063f8982a57?topic=chat" target="_blank"><img class="m" src="https://media2.imgyb.xyz/media/v1/image/1d8a1fe96b0eb322feef7b8ea92bee8e.png" alt=""></a>
        </div>
        <HotSubject id="third-floor" />

        <!--类型选择-->
        <div class="tab-style" id="fourth-floor">
            <div class="item" :class="{active:type==0}" @click="typeChange(0)">精选</div>
            <div class="item" :class="{active:type==1}" @click="typeChange(1)">点赞最多</div>
            <div class="item" :class="{active:type==2}" @click="typeChange(2)">最新发布 </div>
        </div>

        <!---列表展示-->
        <div class="post-list" v-if="list.length>0">
            <template v-for="(item,index) in list" >
                <YorkbbsInfoflowItem v-if="item.app === 'crm_ad'" :data="item" :key="index"></YorkbbsInfoflowItem>
                <ItemSubject v-else :data="item" :key="item.id" />
            </template>

            
            <div class="loading-style" v-if="hasMore && listLoading " ><i class="el-icon-loading"></i> 加载中</div>
        </div>
        <!--操作按钮-->
        <div class="join-play">
            <div class="box">
                <a @click="postLink($event)" :href="'/publish/dining?subject=88ebeacf-27cf-48d7-8fc1-51ebf15b0bde'|hostBuild('forum')" target="_blank"><div><i class="yk yk-cms_edit"></i></div> 参与话题</a>
                <!-- <a @click="postLink($event)" href="javascript:void(0)"><div><i class="yk yk-cms_edit"></i></div> 参与话题</a> -->
            </div>

        </div>
        <CssFooter></CssFooter> 
        <div style="height:100px" class="white-space"></div>
        <RightFixed />
    </div>
</div>
</template>
<script>
import SimpleHead from '@/components/widgets/simple-head.vue'
import TopBanner from '@/components/widgets/top-banner.vue'
import GoodShop from './good-shop.vue'
import HotSubject from './hot-subject.vue'
import ItemSubject from './item-subject.vue'
import { throttle } from 'throttle-debounce';
import { isScrollToPageBottom ,inflowAdvConvert} from '@/utils/utils';
import RightFixed from './right-fixed.vue'
import CssFooter from '@/components/css-footer.vue'
import YorkbbsInfoflowItem from '@/components/item-infoflow.vue'
export default {
    name:'Food2022',
    components:{SimpleHead, TopBanner,GoodShop,HotSubject,ItemSubject,CssFooter,RightFixed,YorkbbsInfoflowItem},
    data(){
        return  {
            banner:{
                pcBanner:'https://media2.imgyb.xyz/media/v1/image/cb20d304c4c803585fd296f001b5e514.png',
                pcBannerBg:'https://media5.imgyb.xyz/media/v1/image/fa8238580ee7d97296d0e031895a136f.png',
                mBanner:'https://media1.imgyb.xyz/media/v1/image/f5fc8a6ca4ac0d8ae0e3af2263dee4dd.png',
                
            },
            type:0,
            params:{   
                "offset": 1,
                "size": 10,
                //"sort": ["property_thumbUpTotal: DESC","property_updatedAt: DESC"],
                "sort":['property_top: DESC','property_commentedAt: DESC'],
                "subject": [
                    "88ebeacf-27cf-48d7-8fc1-51ebf15b0bde"
                ],
                "options":{"elite":[1]},    
            },
            list:[],
            pageComplete:false,
            hasMore:true,
            listLoading:false,
        }
    },
    created(){
        this.getList();
    },
    mounted() {
        window.addEventListener('scroll', this.pageScroll);

        this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('scroll', this.pageScroll);
        });
    },
    methods:{
        shareFun(){
            if( window.navigator.canShare && window.navigator.canShare({url:window.location.origin})){
                navigator.share({
                    title:'这个是title',
                    text:'这个是text字段，看有什么用',
                    url:window.location.origin,
                //text:'这个是text字段，看有什么用'
                })
                .then((res) => {
                console.log(res)
                })
            }
        },
        pageScroll: throttle(300, function () {
            if( isScrollToPageBottom() && this.pageComplete && this.hasMore && !this.listLoading ){
                this.params.offset ++;
                this.getList();
            }
             
            /* let banner = this.$refs['banner'].scrollHeight;
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            if( top>banner-100){
                this.showFunc = true;
            }else{
                this.showFunc = false;
            } */
 
            /* const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            const offsetTop = this.$refs.tab.offsetTop;
            this.tabFixed = scrollTop >= offsetTop; */
        }),
        typeChange(index){
            if( this.type == index) return false;
            delete this.params.options;
            if( index == 0 ){
                this.params.sort = ['property_top: DESC','property_commentedAt: DESC'];
                this.params['options'] = {"elite":[1]};
            }
            if( index ==1 ){
                this.params.sort = ['property_thumbUpTotal: DESC'];
            }
            if( index == 2 ){
                this.params.sort = ['property_commentedAt: DESC'];
            }
            this.type = index;
            this.params.offset = 1;
            this.list = [];
            this.getList();
  
        },
        async getList(){
            this.listLoading = true;
            let result = await this.$axios.post('/bbs/v1/get/post/list/for/subject',this.params);
            this.pageComplete = true;
            this.listLoading = false;
            if( result.code == 0 ){
          
                if( this.params.offset == 1 ){
                    this.list = [];
                }
                var inflowAdv = inflowAdvConvert(result.data.items, 'topic', '3261');
                this.list = this.list.concat(inflowAdv);
                this.hasMore = this.params.offset < result.data.pageTotal;
            }
        },
        postLink(event){
            console.log(event);
            try{
                
                flutterForumPost.postMessage(JSON.stringify({
                    topicId:'9f6ada73-4a8c-457f-8bd9-b9eca97ee4b0',
                    subject:'88ebeacf-27cf-48d7-8fc1-51ebf15b0bde',
                    name:'美食天地'
                }))
                event.preventDefault()
                return false;
            }catch(err){
                return true;
            }
            
        }
    }
}
</script>
<style lang="less" scoped>
.food{background: #F9FB67;}
.good-shop{margin: 30px 0 30px; background: #fff;padding: 35px 33px 0; border: 2px solid #000000; border-radius: 20px;
    .join-in{
        font-size: 16px; color: #FF4526;
        &:hover{text-decoration: underline;}
    }
}
@media screen and (max-width:768px){
  .good-shop{border-radius: 10px;}  
}
.tab-style{
    display: flex; align-items: center; justify-content: center; margin-bottom: 15px !important; z-index: 10; margin-bottom: 30px;
    .item{
        font-size: 14px; line-height: 24px; margin-right: 40px; color: #666; user-select: none; cursor: pointer;
        &:hover{color: #111;}
        &:last-child{margin-right: 0;}
        &.active{
            position: relative; font-weight: bold; z-index: 10; font-size: 18px; color: #111;
            /* &:after{
                position: absolute; content: ''; z-index: -1; left: 0; bottom: 0; right: 0; height: 7px; background: #fa4a83;
            } */
        }
    }

}
@media screen and (min-width:768px){
    .tab-style{
        display: flex; align-items: center; justify-content: center; margin-bottom: 30px !important;
        .item{
            font-size: 18px; line-height: 37px; margin-right: 40px; user-select: none; cursor: pointer;
            &:last-child{margin-right: 0;}
            &.active{
                position: relative; font-weight: bold; font-size: 26px;
                /* &:after{
                    position: absolute; content: ''; left: 0; bottom: 0; right: 0; height: 7px; background: #fa4a83;
                } */
            }
        }

    }
}
/**参加活动按钮 */
.join-play{
    position: fixed; z-index: 100; right: 30px; bottom: 30px; 
    .box{width: 76px; height: 76px; background: #000; color: #fff; border-radius: 50%; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; font-size: 14px;}
   
    div{margin-bottom: 10px;}
    /* position: fixed; z-index: 100; left: 15px; right: 15px; bottom: 25px;
    .box{
        display: flex; align-items: center; background: #000000; height: 40px; font-size: 16px; line-height: 24px; justify-content: center; color: #fff; border-radius: 10px; user-select: none; cursor: pointer;
        a{flex:1; display: flex; align-items: center; justify-content: center; height: 40px;}
        i{font-size: 20px; margin-right:5px;}
        &:hover{color: #f9fb67;}
    } */
}
@media screen and (min-width:768px){
    .join-play{
        right: 0; left: 0;
        .box{width:auto; max-width: 800px; margin: 0 auto; height: 50px; font-size: 20px;  border-radius: 4px; 
            a{height: 50px; display: flex; align-items: center;
                div{margin: 0 5px 0 0 ;}
                &:hover{color: #f9fb67;}
            }
            i{font-size: 26px;}
        }
    }
}
.loading-style{display: flex; margin-bottom: 20px; color: #999; justify-content: center ; align-items: center; font-size: 12px;
    i{margin-right: 5px;}
}
.post-list{background: #fff; border:2px solid #000; border-radius: 20px; padding: 30px; margin-bottom: 30px;
    ::v-deep{
        .infoflow-item{border-bottom: 0; margin-bottom: 10px; padding-left: 46px;}
    }
}
@media screen and (max-width:768px){
    .post-list{padding: 15px; border-radius: 10px;}
}
.note-content{
    .pc{display: none;}
    .m{display: block;}
}
@media screen and (min-width:768px){
    .note-content{
        .pc{display: block;}
        .m{display: none;}
    }
}
.top-baner{margin: 0 auto ; max-width: 800px;}
@media screen and (max-width:768px){
    .white-space{display: none;}
}
</style>